import { DefaultTheme } from 'styled-components'

const stateOfCSSThemeDimensions: DefaultTheme['dimensions'] = {
    spacing: 20,
    sidebar: {
        width: 240,
    },
}

export default stateOfCSSThemeDimensions
